export function getTextForMaritalStatus(statusInt) {
  switch (statusInt) {
    case 9000:
      return "Never married";
    case 9001:
      return "Widowed";
    case 9002:
      return "Separated";
    case 9003:
      return "Divorced";
    default:
      return "Unknown";
  }
}

export function getMaritalStatusForDropDown() {
  return [
    { value: null, text: "Marital Status", color: "secondary" },
    { value: 9000, text: "Never married", color: "success" },
    { value: 9001, text: "Widowed", color: "success" },
    { value: 9002, text: "Separated", color: "success" },
    { value: 9003, text: "Divorced", color: "success" },
  ];
}

export function getTextForReligion(rel) {
  switch (rel) {
    case "11001":
      return "Buddhism";
    case "11002":
      return "Christianity";
    case "11003":
      return "Catholicism";
    case "11004":
      return "Free Thinker";
    case "11005":
      return "Hinduism";
    case "11006":
      return "Judaism";
    case "11007":
      return "Islam";
    case "11008":
      return "No Religion";
    case "11009":
      return "Zoroastrianism";
    case "11010":
      return "Others";
  }
}

export function getReligionDropDown() {
  return [
    { value: null, text: "Religion", color: "secondary" },
    { value: 11001, text: "Buddhism", color: "success" },
    { value: 11002, text: "Christianity", color: "success" },
    { value: 11003, text: "Catholicism", color: "success" },
    { value: 11004, text: "Free Thinker", color: "success" },
    { value: 11005, text: "Hinduism", color: "success" },
    { value: 11006, text: "Judaism", color: "success" },
    { value: 11007, text: "Islam", color: "success" },
    { value: 11008, text: "No Religion", color: "success" },
    { value: 11009, text: "Zoroastrianism", color: "success" },
    { value: 11010, text: "Others", color: "success" },
  ];
}

export function getTextForEthnicity(eth) {
  switch (eth) {
    case 9200:
      return "Caucasian";
    case 9201:
      return "Arab";
    case 9202:
      return "Chinese";
    case 9203:
      return "Eurasian";
    case 9204:
      return "Korean";
    case 9205:
      return "Indian";
    case 9206:
      return "Japanese";
    case 9207:
      return "Malay";
    case 9208:
      return "Others";
  }
}

export function getEthnicityDropDown() {
  return [
    { value: null, text: "Ethnicity", color: "secondary" },
    { value: 9200, text: "Caucasian", color: "success" },
    { value: 9201, text: "Arab", color: "success" },
    { value: 9202, text: "Chinese", color: "success" },
    { value: 9203, text: "Eurasian", color: "success" },
    { value: 9204, text: "Korean", color: "success" },
    { value: 9205, text: "Indian", color: "success" },
    { value: 9206, text: "Japanese", color: "success" },
    { value: 9207, text: "Malay", color: "success" },
    { value: 9208, text: "Others", color: "success" },
  ];
}

export function getStatusDropDown() {
  return [
    { value: null, text: "Status", color: "secondary" },
    { value: 23, text: "Approved", color: "success" },
    { value: 99, text: "BlackLabel", color: "success" },
    { value: 31, text: "Coaching", color: "success" },
    { value: 10, text: "Dnc", color: "success" },
    { value: 96, text: "Expired", color: "success" },
    { value: 21, text: "Followup", color: "success" },
    { value: 20, text: "Headhunted", color: "success" },
    { value: 98, text: "Luxe", color: "success" },
    { value: 95, text: "Participant", color: "success" },
    { value: 22, text: "Pending", color: "success" },
    { value: 2, text: "Registered", color: "success" },
    { value: 97, text: "Super Luxe", color: "success" },
    { value: 100, text: "Waitlist", color: "success" },
  ];
}
export function getTextForStatus(sta) {
  switch (sta) {
    case 2:
      return "Registered";
    case 20:
      return "Headhunted";
    case 21:
      return "Followup";
    case 22:
      return "Pending";
    case 23:
      return "Approved";
    case 95:
      return "Participant";
    case 96:
      return "Expired";
    case 97:
      return "Super Luxe";
    case 98:
      return "Luxe";
    case 99:
      return "BlackLabel";
    case 100:
      return "WaitList";
    case 10:
      return "dnc";
    default:
      return "?";
  }
}

export function getTextForProfession(prof) {
  switch (prof) {
    case 10300:
      return "Accountant";
    case 10301:
      return "Actuary";
    case 10302:
      return "Academician";
    case 10303:
      return "Advertising";
    case 10304:
      return "Anthropologist";
    case 10305:
      return "Auditor";
    case 10306:
      return "Aviation";
    case 10307:
      return "Archeologist";
    case 10308:
      return "Architect";
    case 10309:
      return "Artist";
    case 10400:
      return "Banker";
    case 10401:
      return "Biologist";
    case 10402:
      return "Botanist";
    case 10403:
      return "Broadcaster";
    case 10404:
      return "Business owner";
    case 10405:
      return "Chemist";
    case 10406:
      return "Charter Agent / Ship Broker ";
    case 10407:
      return "Chemical Researcher";
    case 10408:
      return "Chemical Engineer";
    case 10409:
      return "CEO/C-suite executive";
    case 10410:
      return "Choreographer";
    case 10411:
      return "Coach";
    case 10412:
      return "Computer Programmer ";
    case 10413:
      return "Composer";
    case 10414:
      return "Conservator";
    case 10415:
      return "Dancer";
    case 10416:
      return "Dentist";
    case 10417:
      return "Doctor";
    case 10418:
      return "Dietitian";
    case 10419:
      return "Developer";
    case 10420:
      return "Director ";
    case 10421:
      return "Ecologist";
    case 10422:
      return "Economist";
    case 10423:
      return "Editor";
    case 10424:
      return "Educator";
    case 10425:
      return "Engineer";
    case 10426:
      return "Entrepreneur";
    case 10427:
      return "Environmentalist";
    case 10428:
      return "Exhibitions Manager";
    case 10429:
      return "Fashion Designer";
    case 10430:
      return "Film Critic / Film Maker ";
    case 10431:
      return "Financier ";
    case 10432:
      return "Financial Analyst";
    case 10433:
      return "Food Industry Technologist";
    case 10434:
      return "General Anesthetist";
    case 10435:
      return "General Practitioner";
    case 10436:
      return "Geologist";
    case 10437:
      return "Geophysicist";
    case 10438:
      return "Goldsmith";
    case 10439:
      return "Government";
    case 10440:
      return "Hotelier";
    case 10441:
      return "Herbalist";
    case 10442:
      return "Industrial engineer";
    case 10443:
      return "IT";
    case 10444:
      return "Insurance";
    case 10445:
      return "Investment Officer";
    case 10446:
      return "Investor";
    case 10447:
      return "Image Consultant";
    case 10448:
      return "Jeweler";
    case 10449:
      return "Judge";
    case 10450:
      return "Journalist";
    case 10451:
      return "Lawyer";
    case 10452:
      return "Lecturer";
    case 10453:
      return "Management consultant";
    case 10454:
      return "Marine Engineer";
    case 10455:
      return "Mathematician";
    case 10456:
      return "Mechanic";
    case 10457:
      return "Money Broker";
    case 10458:
      return "Microbiologist";
    case 10459:
      return "Miner / Mining ";
    case 10460:
      return "Model";
    case 10461:
      return "Multimedia designer";
    case 10462:
      return "Musician";
    case 10463:
      return "News Editor";
    case 10464:
      return "Nutritionist";
    case 10465:
      return "Nurse";
    case 10466:
      return "Optician";
    case 10467:
      return "Obstetrician &amp; Gynecologist";
    case 10468:
      return "Orthopedic Surgeon";
    case 10469:
      return "Orthodontist";
    case 10470:
      return "Pediatrician";
    case 10471:
      return "Politician";
    case 10472:
      return "Pharmacist";
    case 10473:
      return "Philosopher";
    case 10474:
      return "Photographer";
    case 10475:
      return "Physicist";
    case 10476:
      return "Pharmacist";
    case 10477:
      return "Pilot";
    case 10478:
      return "Political Scientist";
    case 10479:
      return "Producer";
    case 10480:
      return "Psychologist";
    case 10481:
      return "Psychotherapist";
    case 10482:
      return "Publisher";
    case 10483:
      return "Public Relations";
    case 10484:
      return "Radiologist";
    case 10485:
      return "Railway Engineer";
    case 10486:
      return "Sales and Marketing";
    case 10487:
      return "Scientist";
    case 10488:
      return "Safety Engineer";
    case 10489:
      return "Sculptor";
    case 10490:
      return "School Inspector";
    case 10491:
      return "Script Writer";
    case 10492:
      return "Spa Owner";
    case 10493:
      return "Stockbroker";
    case 10494:
      return "Systems Engineer";
    case 10495:
      return "Teacher";
    case 10496:
      return "Tax Adviser / Tax Specialist ";
    case 10497:
      return "Valuer";
    case 10498:
      return "Veterinarian ";
    case 10499:
      return "Viniculturist ";
    case 10599:
      return "Others ";
    case 104100:
      return "Real Estate";
  }
}

export function getProfessionDropDown() {
  return [
    { value: null, text: "Profession", color: "secondary" },
    { value: 10300, text: "Accountant", color: "success" },
    { value: 10301, text: "Actuary", color: "success" },
    { value: 10302, text: "Academician", color: "success" },
    { value: 10303, text: "Advertising", color: "success" },
    { value: 10304, text: "Anthropologist", color: "success" },
    { value: 10305, text: "Auditor", color: "success" },
    { value: 10306, text: "Aviation", color: "success" },
    { value: 10307, text: "Archeologist", color: "success" },
    { value: 10308, text: "Architect", color: "success" },
    { value: 10309, text: "Artist", color: "success" },
    { value: 10400, text: "Banker", color: "success" },
    { value: 10401, text: "Biologist", color: "success" },
    { value: 10402, text: "Botanist", color: "success" },
    { value: 10403, text: "Broadcaster", color: "secondary" },
    { value: 10404, text: "Business owner", color: "secondary" },
    { value: 10405, text: "Chemist", color: "secondary" },
    { value: 10406, text: "Charter Agent / Ship Broker ", color: "secondary" },
    { value: 10407, text: "Chemical Researcher", color: "secondary" },
    { value: 10408, text: "Chemical Engineer", color: "secondary" },
    { value: 10409, text: "CEO/C-suite executive", color: "secondary" },
    { value: 10410, text: "Choreographer", color: "secondary" },
    { value: 10411, text: "Coach", color: "secondary" },
    { value: 10412, text: "Computer Programmer ", color: "secondary" },
    { value: 10413, text: "Composer", color: "secondary" },
    { value: 10414, text: "Conservator", color: "secondary" },
    { value: 10415, text: "Dancer", color: "secondary" },
    { value: 10416, text: "Dentist", color: "secondary" },
    { value: 10417, text: "Doctor", color: "secondary" },
    { value: 10418, text: "Dietitian", color: "secondary" },
    { value: 10419, text: "Developer", color: "secondary" },
    { value: 10420, text: "Director ", color: "secondary" },
    { value: 10421, text: "Ecologist", color: "secondary" },
    { value: 10422, text: "Economist", color: "secondary" },
    { value: 10423, text: "Editor", color: "secondary" },
    { value: 10424, text: "Educator", color: "secondary" },
    { value: 10425, text: "Engineer", color: "secondary" },
    { value: 10426, text: "Entrepreneur", color: "secondary" },
    { value: 10427, text: "Environmentalist", color: "secondary" },
    { value: 10428, text: "Exhibitions Manager", color: "secondary" },
    { value: 10429, text: "Fashion Designer", color: "secondary" },
    { value: 10430, text: "Film Critic / Film Maker ", color: "secondary" },
    { value: 10431, text: "Financier ", color: "secondary" },
    { value: 10432, text: "Financial Analyst", color: "secondary" },
    { value: 10433, text: "Food Industry Technologist", color: "secondary" },
    { value: 10434, text: "General Anesthetist", color: "secondary" },
    { value: 10435, text: "General Practitioner", color: "secondary" },
    { value: 10436, text: "Geologist", color: "secondary" },
    { value: 10437, text: "Geophysicist", color: "secondary" },
    { value: 10438, text: "Goldsmith", color: "secondary" },
    { value: 10439, text: "Government", color: "secondary" },
    { value: 10440, text: "Hotelier", color: "secondary" },
    { value: 10441, text: "Herbalist", color: "secondary" },
    { value: 10442, text: "Industrial engineer", color: "secondary" },
    { value: 10443, text: "IT", color: "secondary" },
    { value: 10444, text: "Insurance", color: "secondary" },
    { value: 10445, text: "Investment Officer", color: "secondary" },
    { value: 10446, text: "Investor", color: "secondary" },
    { value: 10447, text: "Image Consultant", color: "secondary" },
    { value: 10448, text: "Jeweler", color: "secondary" },
    { value: 10449, text: "Judge", color: "secondary" },
    { value: 10450, text: "Journalist", color: "secondary" },
    { value: 10451, text: "Lawyer", color: "secondary" },
    { value: 10452, text: "Lecturer", color: "secondary" },
    { value: 10453, text: "Management consultant", color: "secondary" },
    { value: 10454, text: "Marine Engineer", color: "secondary" },
    { value: 10455, text: "Mathematician", color: "secondary" },
    { value: 10456, text: "Mechanic", color: "secondary" },
    { value: 10457, text: "Money Broker", color: "secondary" },
    { value: 10458, text: "Microbiologist", color: "secondary" },
    { value: 10459, text: "Miner / Mining ", color: "secondary" },
    { value: 10460, text: "Model", color: "secondary" },
    { value: 10461, text: "Multimedia designer", color: "secondary" },
    { value: 10462, text: "Musician", color: "secondary" },
    { value: 10463, text: "News Editor", color: "secondary" },
    { value: 10464, text: "Nutritionist", color: "secondary" },
    { value: 10465, text: "Nurse", color: "secondary" },
    { value: 10466, text: "Optician", color: "secondary" },
    { value: 10467, text: "Obstetrician &amp; Gynecologist", color: "secondary" },
    { value: 10468, text: "Orthopedic Surgeon", color: "secondary" },
    { value: 10469, text: "Orthodontist", color: "secondary" },
    { value: 10470, text: "Pediatrician", color: "secondary" },
    { value: 10471, text: "Politician", color: "secondary" },
    { value: 10472, text: "Pharmacist", color: "secondary" },
    { value: 10473, text: "Philosopher", color: "secondary" },
    { value: 10474, text: "Photographer", color: "secondary" },
    { value: 10475, text: "Physicist", color: "secondary" },
    { value: 10476, text: "Pharmacist", color: "secondary" },
    { value: 10477, text: "Pilot", color: "secondary" },
    { value: 10478, text: "Political Scientist", color: "secondary" },
    { value: 10479, text: "Producer", color: "secondary" },
    { value: 10480, text: "Psychologist", color: "secondary" },
    { value: 10481, text: "Psychotherapist", color: "secondary" },
    { value: 10482, text: "Publisher", color: "secondary" },
    { value: 10483, text: "Public Relations", color: "secondary" },
    { value: 10484, text: "Radiologist", color: "secondary" },
    { value: 10485, text: "Railway Engineer", color: "secondary" },
    { value: 10486, text: "Sales and Marketing", color: "secondary" },
    { value: 10487, text: "Scientist", color: "secondary" },
    { value: 10488, text: "Safety Engineer", color: "secondary" },
    { value: 10489, text: "Sculptor", color: "secondary" },
    { value: 10490, text: "School Inspector", color: "secondary" },
    { value: 10491, text: "Script Writer", color: "secondary" },
    { value: 10492, text: "Spa Owner", color: "secondary" },
    { value: 10493, text: "Stockbroker", color: "secondary" },
    { value: 10494, text: "Systems Engineer", color: "secondary" },
    { value: 10495, text: "Teacher", color: "secondary" },
    { value: 10496, text: "Tax Adviser / Tax Specialist ", color: "secondary" },
    { value: 10497, text: "Valuer", color: "secondary" },
    { value: 10498, text: "Veterinarian ", color: "secondary" },
    { value: 10499, text: "Viniculturist ", color: "secondary" },
    { value: 10599, text: "Others ", color: "secondary" },
    { value: 104100, text: "Real Estate", color: "secondary" },
  ];
}
